/**
 * Red Envelopes (抢红包) — all numbers of the game. No logic here.
 *
 * Shared rounds per table (room): every player at a table stakes the table's fixed amount; with 2+
 * players a countdown runs, at `maxPlayers` the round starts at once. The bank minus the house fee is
 * split into as many random envelopes as there are players, and every player gets one envelope.
 * fee = floor(bank × feeBps / 10 000), pool = bank − fee, so the RTP of a round is exactly pool / bank
 * (the floor works in the players' favour: 95 % … 97.2 % depending on the table and the number of players).
 *
 * The numbers we choose avoid the digit 4 (tables, capacity, fee, timings).
 */
export interface HongbaoConfig {
  /** tables by fixed stake, tokens */
  readonly rooms: readonly number[];
  /** the countdown starts once this many players sit at the table */
  readonly minPlayers: number;
  /** table capacity: the round starts immediately when it is full */
  readonly maxPlayers: number;
  /** house fee in basis points of the bank (500 = 5 %) */
  readonly feeBps: number;
  /** countdown after the second player, ms */
  readonly countdownMs: number;
  /** envelopes are "handed out": result published, seed still hidden, ms */
  readonly openingMs: number;
  /** seed revealed, before the next round opens, ms */
  readonly finishedMs: number;
  /** last rounds of a table kept in its state */
  readonly historyLimit: number;
}

export const HONGBAO_CONFIG: HongbaoConfig = {
  rooms: [18, 88, 888],
  minPlayers: 2,
  maxPlayers: 8,
  feeBps: 500,
  countdownMs: 15_000,
  openingMs: 6_000,
  finishedMs: 5_000,
  historyLimit: 8,
};
